export type OrganizationalFormShort =
  | 'ООО'
  | 'ИП'
  | 'ОАО'
  | 'АО'
  | 'ЗАО'
  | 'ПАО'
  | 'ФГБУ'

export interface OrganizationalFormOption {
  value: OrganizationalFormShort
  label: string
}

export const organizationalFormMap: Record<OrganizationalFormShort, string> = {
  ООО: 'Общество с ограниченной ответственностью',
  ИП: 'Индивидуальный предприниматель',
  ОАО: 'Открытое акционерное общество',
  АО: 'Акционерное общество',
  ЗАО: 'Закрытое акционерное общество',
  ПАО: 'Публичное акционерное общество',
  ФГБУ: 'Федеральное государственное бюджетное учреждение',
}

export const organizationalFormOptions: OrganizationalFormOption[] = [
  { value: 'ООО', label: 'ООО' },
  { value: 'ИП', label: 'ИП' },
  { value: 'ОАО', label: 'ОАО' },
  { value: 'АО', label: 'АО' },
  { value: 'ЗАО', label: 'ЗАО' },
  { value: 'ПАО', label: 'ПАО' },
  { value: 'ФГБУ', label: 'ФГБУ' },
]

export const getFullOrganizationalForm = (
  shortForm: string | null | undefined,
): string => {
  if (!shortForm) return ''
  return (
    organizationalFormMap[shortForm as OrganizationalFormShort] || shortForm
  )
}

export const formatClientName = (
  client?: { organizationalForm?: string | null; name?: string | null } | null,
): string =>
  [client?.organizationalForm, client?.name]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ')
